// src/firebase.js
import { initializeApp, getApps } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: 'AIzaSyCdgVFCEC5KujgQn7MaMrx3WToXgzOBoSY',
  authDomain: 'ampthill-77f7f.firebaseapp.com',
  projectId: 'ampthill-77f7f',
  storageBucket: 'ampthill-77f7f.firebasestorage.app',
  messagingSenderId: '654363714575',
  appId: '1:654363714575:web:2cee87839eef6d08f42f7a',
  measurementId: 'G-0SWBSL6GJW',
}

const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig)
const db = getFirestore(app)
const storage = getStorage(app)

export { db, storage }
